import React, { FC } from "react";

import OrganizationSettings from "./OrganizationSettings";
import OrganizationSettingsSkeleton from "./OrganizationSettings.skeleton";

import { useGetCurrentCompanyInfo, useGetCurrentCompanySettings } from "@api";
import { useUserStore } from "@store/user";

const OrganizationSettingsContainer: FC = () => {
  const { user } = useUserStore();
  const { currentCompanyInfo, isFetchingCurrentCompanyInfo } =
    useGetCurrentCompanyInfo(user);
  const {
    currentCompanySettings,
    currentCompanySettingsEnabled,
    isFetchingCurrentCompanySettings,
  } = useGetCurrentCompanySettings(user);

  return (
    currentCompanySettingsEnabled &&
    (isFetchingCurrentCompanyInfo || isFetchingCurrentCompanySettings ? (
      <OrganizationSettingsSkeleton />
    ) : currentCompanyInfo && currentCompanySettings ? (
      <OrganizationSettings
        currentCompanyInfo={currentCompanyInfo}
        currentCompanySettings={currentCompanySettings}
      />
    ) : (
      "Company settings not found"
    ))
  );
};

export default OrganizationSettingsContainer;
